import { render } from "./login-page.vue?vue&type=template&id=3664a9f0&ts=true"
import script from "./login-page.vue?vue&type=script&lang=ts"
export * from "./login-page.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__